import React from 'react';
import { noData } from '../../../utils/string';
import { createAmazonUrl } from '../../Amazon/util';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ConnectAmazonAccount from '../../Amazon/Layout';
import { CustomTooltip } from '../../BuildingBlocks/Tooltip/Tooltip';
import Status from '../../BuildingBlocks/Misc/Status';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  table: {
    '& .MuiTableCell-root': {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  },
  header: { fontWeight: 'bold' },
  tableBody: {
    height: theme.spacing(7),
  },
  connected: { color: theme.palette.status.active },
  notConnected: { color: theme.palette.error.main },
  center: { textAlign: 'center' },
  connectButton: { marginTop: theme.spacing(2) },
  noAccountsNote: {
    height: theme.spacing(6),
    width: '100%',
    backgroundColor: theme.palette.primary.light,
    border: `1px solid ${theme.palette.brand.blueSky}`,
    color: theme.palette.primary.main,
    borderRadius: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  content: {
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },
}));

export default function AmazonAccounts({ amzAccounts }) {
  const classes = useStyles();
  const headers = ['Store Name', 'Seller ID', 'Status'];
  const hasConnectedAccount =
    amzAccounts.findIndex((account) => account.connected) > -1;
  return (
    <React.Fragment>
      <div className={classes.content}>
        {amzAccounts.length === 0 && (
          <div className={classes.noAccountsNote}>
            <Typography>
              No Amazon Seller accounts connected. Connect an Amazon Seller
              account to get a custom 8fig Growth Plan.
            </Typography>
          </div>
        )}
        {amzAccounts.length > 0 && (
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {headers.map((header) => (
                  <TableCell key={header} className={classes.header}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {amzAccounts.map((account, i) => (
                <TableRow key={i} className={classes.tableBody}>
                  <TableCell>{account.name}</TableCell>
                  <TableCell>
                    {account.sellerId ? account.sellerId : noData()}
                  </TableCell>
                  <TableCell>
                    {account.connected ? (
                      <CustomTooltip arrow title="Connected" placement="top">
                        <>
                          <Status status="connected" />
                        </>
                      </CustomTooltip>
                    ) : (
                      <CustomTooltip arrow title="Connect" placement="top">
                        <>
                          <Status
                            status="notConnected"
                            label="Not Connected"
                            onClick={() =>
                              window.open(createAmazonUrl(account.id))
                            }
                          />
                        </>
                      </CustomTooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        <div className={classes.connectButton}>
          <ConnectAmazonAccount disabled={hasConnectedAccount} />
        </div>
      </div>
    </React.Fragment>
  );
}
